import { HEADER_IMG_ERROR_FALLBACK } from 'consts/consts';
import { HEADER_TYPE } from 'consts/enum';
import './headerIcon.scss';

export const HeaderIconTemplate = (model) => {
	const { img, forceShow, headerType } = model;
	const headerClass = headerType === HEADER_TYPE.TEXT_WITH_IMAGE ? 'engt-header-icon' : 'engt-header-icon-image';
	/* html */
	const botImgTag =
		img || forceShow
			? `<img src="${img}" class="${headerClass}" alt="engt-title-img" onError="this.onerror=null;this.src='${HEADER_IMG_ERROR_FALLBACK}';" loader="lazy"/>`
			: '';

	return botImgTag;
};
